import React from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

/**
 * Modal for warning messages
 * @returns {JSX.Element}
 * @constructor
 */
const ModalWarning = (props) => {
    const {
        modal,
        setModal,
        title,
    } = props;

    const toggle = () => setModal({...modal, isOpen: !modal.isOpen});

    return (
        <Modal isOpen={modal.isOpen} toggle={toggle} className="modal-body" centered={true} >
            <ModalHeader toggle={toggle}>{title}</ModalHeader>
            <ModalBody>{modal.message}</ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Ok</Button>
            </ModalFooter>
        </Modal>
    );
}

export default ModalWarning;
